export class ChangeDocumentOwnerRawDto {
    customerId: string;
    communityId: number;
    fileId: number;
}
